export const BUILDINGS_CONSTS = {
    GET_BUILDINGS: "GET_BUILDINGS",
    GET_BUILDING_BY_ID: "GET_BUILDING_BY_ID",
    CLEAR_BUILDING_BY_ID: "CLEAR_BUILDING_BY_ID",

    //Houses Constants
    GET_HOUSES: "GET_HOUSES",
    VIEW_HOUSE: "VIEW_HOUSE",
};
